import React from 'react';

const IFrame = ({ src }) => {
    return (
        <iframe src={ src }></iframe>
    )
}


export default IFrame;